import { Bot, FileText, Smartphone, Gift, Clock, Phone } from "lucide-react";
import MobileLayout from "@/components/MobileLayout";
import { Link } from "react-router-dom";

export default function AssistantPage() {
  return (
    <MobileLayout>
      <div className="mb-6">
        <div className="inline-flex items-center gap-2 rounded-full bg-[#4d7c0f]/10 px-4 py-2 text-sm font-black text-[#4d7c0f]">
          <Bot className="h-4 w-4" />
          Asistente KAPEI
        </div>
        <h1 className="mt-3 text-4xl font-black tracking-tight text-slate-900">
          ¿Cómo podemos ayudarte?
        </h1>
        <p className="mt-2 text-base text-slate-600">
          Encuentra ayuda rápida sobre envíos, pedidos, promociones y contacto con KAPEI.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-3">
        <Link to="/help" className="kapei-card flex items-center gap-4 text-left">
          <FileText className="h-7 w-7 text-[#4d7c0f]" />
          <div>
            <div className="font-black text-slate-900">Cómo enviar archivos</div>
            <div className="text-sm text-slate-600">Guía rápida de uso de la app.</div>
          </div>
        </Link>

        <Link to="/help" className="kapei-card flex items-center gap-4 text-left">
          <Smartphone className="h-7 w-7 text-[#4d7c0f]" />
          <div>
            <div className="font-black text-slate-900">Problemas con la app</div>
            <div className="text-sm text-slate-600">Instalación, acceso y funcionamiento.</div>
          </div>
        </Link>

        <Link to="/club" className="kapei-card flex items-center gap-4 text-left">
          <Gift className="h-7 w-7 text-[#4d7c0f]" />
          <div>
            <div className="font-black text-slate-900">Promociones y sorteos</div>
            <div className="text-sm text-slate-600">Consulta tu Club KAPEI.</div>
          </div>
        </Link>

        <Link to="/contact" className="kapei-card flex items-center gap-4 text-left">
          <Clock className="h-7 w-7 text-[#4d7c0f]" />
          <div>
            <div className="font-black text-slate-900">Horarios y ubicación</div>
            <div className="text-sm text-slate-600">Teléfono, dirección y contacto.</div>
          </div>
        </Link>

        <Link to="/contact" className="kapei-card flex items-center gap-4 text-left">
          <Phone className="h-7 w-7 text-[#4d7c0f]" />
          <div>
            <div className="font-black text-slate-900">Hablar con KAPEI</div>
            <div className="text-sm text-slate-600">Contacta directamente con la tienda.</div>
          </div>
        </Link>
      </div>
    </MobileLayout>
  );
}
